import { create } from 'zustand';

interface IPrintComponentState {
  hasAnswerSheet: boolean;
  hasMoreExercises: boolean;
  numberOfColumns: string;
  hasApiCall: boolean;
  data: any[];
  page: number;
  setPage: (page: number) => void;
  setData: (data: any[] | any | null) => void;
  setHasAnswerSheet: (check: boolean) => void;
  setHasMoreExercises: (check: boolean) => void;
  setHasApiCall: (check: boolean) => void;
  setNumberOfColumn: (columns: string) => void;
  reset: () => void;
}

export const usePrintComponentStore = create<IPrintComponentState>(
  (set) => ({
    hasAnswerSheet: false,
    hasMoreExercises: false,
    hasApiCall: false,
    numberOfColumns: 'split',
    data: [],
    page: 1,
    setPage: (page: number) => set({ page }),
    setData: (data: any[] | any | null) => set({ data: data }),
    setHasAnswerSheet: (check: boolean) => set({ hasAnswerSheet: check }),
    setHasMoreExercises: (check: boolean) => set({ hasMoreExercises: check }),
    setHasApiCall: (check: boolean) => set({ hasApiCall: check }),
    setNumberOfColumn: (columns: string) => set({ numberOfColumns: columns }),
    reset: () => set({
      hasAnswerSheet: false,
      hasMoreExercises: false,
      hasApiCall: false,
    })
  })
);
